export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";